<template>
	<div>
		<van-sticky>
			<navbar :title="title" />
		</van-sticky>

		<van-form @submit="onSubmit" style="padding-bottom: 50px;">
			<van-field v-model="product_text" name="采购商品" label="采购商品" placeholder="选择采购商品" readonly @click="popup.select = true" :rules="[{ required: true, trigger: 'onBlur', message: '请选择采购商品' }]" />
			<!-- <van-field v-model="form.supplier" name="供应商" label="供应商" placeholder="请输入供应商" :rules="[{ required: true, message: '请填写供应商' }]" /> -->
			<!-- <van-field v-model="form.supplier" name="供应商" label="供应商" placeholder="选择供应商" readonly @click="popup.select1 = true" :rules="[{ required: true, trigger: 'onBlur', message: '请选择供应商' }]" /> -->
			<van-field
				v-model="order_text"
				name="关联订单"
				label="关联订单"
				placeholder="选择关联订单"
				readonly
				@click="popup.order = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择关联订单' }]"
			/>
			<van-field v-model="form.quantity" name="采购数量" label="采购数量" type="digit" placeholder="请输入采购数量" :rules="[{ required: true, message: '请填写正确采购数量' }]" />
			<van-field v-model="form.purchase_remark" rows="3" autosize label="备注" type="textarea" placeholder="请输入备注" :rules="[{ required: true, message: '请填写备注' }]" />
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">提交</van-button>
			</div>
		</van-form>

		<van-popup v-model="popup.select" position="right" :style="{ width: '60%', height: '100%' }">
			<popup-select v-model="productList.list" @onload="onload" @check="check" :loading="productList.loading" :finished="productList.finished" value-key="name"></popup-select>
		</van-popup>

		<van-popup v-model="popup.select1" position="right" :style="{ width: '60%', height: '100%' }">
			<popup-select v-model="supplierList.list" @onload="onloada" @check="check1" :loading="supplierList.loading" :finished="supplierList.finished" value-key="supplier_name"></popup-select>
		</van-popup>
		<van-popup v-model="popup.order" position="right" :style="{ width: '60%', height: '100%'}">
			<popup-select
				v-model="orderList.list"
				@onload="onloadOrder"
				@check="checkOrder"
				:loading="orderList.loading"
				:finished="orderList.finished"
				value-key="order_name"
			></popup-select>
		</van-popup>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import popupselect from "@/components/select/index";
import { post } from "@/api/post";
import { Toast } from "vant";
import { getToken } from "@/utils/auth";
export default {
	name: "customer",
	components: {
		navbar,
		"popup-select": popupselect,
	},
	data() {
		return {
			title: "新建采购",
			activeName: "add",
			popup: {
				select: false,
				select1: false,
				order: false,
			},
			form: {
				requestType: "purchase_save",
				product_id: "",
				supplier: "",
				order_id: "",
				quantity: "",
				purchase_remark: "",
				token: getToken(),
			},
			product_text: "",
			productList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 25,
			},
			order_text: "",
			orderList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 20000
			},
			supplierList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 25,
			},
		};
	},
	methods: {
		onSubmit() {
			post(this.form)
				.then(() => {
					for (var key in this.form) {
						if (key != "type" && key != "requestType") {
							this.form[key] = "";
						}
					}
					this.product_text = "";
					Toast.success("新增成功");
					this.$router.go(-1);
				})
				.catch(() => {
					Toast.fail("数据异常");
				});
		},
		check(value) {
			console.log(5);
			this.popup.select = false;
			this.product_text = value.name;
			this.form.product_id = value.value;
			this.form.supplier = value.supplier_name;
			console.log(value.supplier_name, "value", this.product_text);
		},
		check1(value) {
			console.log(6);
			this.popup.select1 = false;
			this.form.supplier = value.supplier_name;
			console.log(value.supplier_name, "value");
		},
		checkOrder(value) {
			this.popup.order = false;
			this.order_text = value.order_name;
			this.form.order_id = value.order_id;
		},
		onload(search) {
			if (search != undefined) {
				this.productList.product_name = search;
				this.productList.page = 1;
			} else {
				this.productList.product_name = "";
			}

			post({
				requestType: "product_list_data",
				page: this.productList.page,
				limit: this.productList.limit,
				product_name: this.productList.product_name,
			})
				.then((res) => {
					if (res.obj.rows.length === 0) {
						this.productList.finished = true;
					}
					if (this.productList.page != 1) {
						this.productList.list = this.productList.list.concat(res.obj.rows);
					} else {
						this.productList.list = res.obj.rows;
					}

					this.productList.page += 1;
					this.productList.loading = false;
				})
				.catch((err) => {
					console.log(err);
					this.productList.loading = false;
					this.productList.finished = true;
					return Toast.fail("数据异常");
				});
		},
		onloadOrder(search) {
			if (search != undefined) {
				this.orderList.page = 1;
			}
			post({
				requestType: "order_list_data",
				page: this.orderList.page,
				limit: this.orderList.limit,
				order_name: search
			})
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.orderList.finished = true;
					}
					if (this.orderList.page != 1) {
						this.orderList.list = this.orderList.list.concat(
							res.obj.rows
						);
					} else {
						this.orderList.list = res.obj.rows;
					}

					this.orderList.page += 1;
					this.orderList.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.orderList.loading = false;
					this.orderList.finished = true;
					return Toast.fail("数据异常");
				});
		},
		onloada() {
			post({
				requestType: "commodity_supplier_list",
				page: this.supplierList.page,
				limit: this.supplierList.limit,
			})
				.then((res) => {
					this.supplierList.list = res.obj.rows;
				})
				.catch((err) => {
					console.log(err);

					return Toast.fail("数据异常");
				});
		},
	},
};
</script>

<style></style>
